import React from 'react'
import { Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import TodayIcon from '@mui/icons-material/Today';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import { styled } from '@mui/material/styles';
import tableCellClasses from '@mui/material/TableCell';



function items(dict, fn) {
  return Object.keys(dict).map((key, i) => {
    return fn(key, dict[key], i)
  })
}
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: "0px 0px",

  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 5,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },

}));


export const RecursoItems = ({ recurso }) => {

  return (
    <>
      <h1 style={{ fontSize: 18, fontWeight: "bold", textAlign: "left", padding: 4, marginTop: 30 }}>Datos del Trámite</h1>
      <Table style={{ padding: 4, marginTop: 0 }}>
        <TableBody>
          {items(recurso, (key, value, i) => (
            <StyledTableRow key={key}>
              <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{key}: </Typography> </StyledTableCell>
              <StyledTableCell align="left" style={{ padding: 4 }}>{value}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </>
  )
}
